import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import confetti from 'canvas-confetti';
import { formatCurrencyByLocaleShort } from '@renenet/shared/src/utils/currencyUtils';

function MilestoneCelebration({ milestone, currencyInfo, onClose }) {
  useEffect(() => {
    if (!milestone) return;

    const end = Date.now() + 3000;
    const colors = ['#50C878', '#ffffff', '#F5DF4D'];

    (function frame() {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors,
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors,
      });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  }, [milestone]);

  if (!milestone) return null;

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Body className="text-center py-5">
        <div style={{ fontSize: '72px', lineHeight: 1 }}>{milestone.emoji}</div>
        <h3 className="mt-3 mb-1" style={{ color: '#50C878', fontWeight: 700 }}>{milestone.title}</h3>
        <p className="text-muted mb-1">You've crossed the <strong>{formatCurrencyByLocaleShort(currencyInfo.locale, currencyInfo.aggregationCurrency, milestone.amount)}</strong> milestone.</p>
        <p className="text-muted mb-4">Keep tracking. The next milestone awaits.</p>
        <Button variant="primary" onClick={onClose}>Keep Going</Button>
      </Modal.Body>
    </Modal>
  );
}

export default MilestoneCelebration;
